import React, { PureComponent } from "react"

/* Icons */
import { CaretDownOutlined } from '@ant-design/icons'

/* Constants */
import { utils } from "../constants"

/* Components */
import { Picture } from "../components"

/* Moment */
import moment from "moment"
import 'moment/locale/ru'
moment.locale('ru')

/* Component History */
class History extends PureComponent {

    constructor() {
        super()

        this.state = {
            active: -1
        }

        this._history = null
    }

    tr = (text) => {
        const { params } = this.props
        return utils.translate(text, params.lang)
    }

    withCr = (value, currency) => {
        return utils.getWithCurrency(value, currency)
    }

    /* Determine and draw total */
    _total = data => {

        let total = 0
        let currency = "USD"

        if (data.transactions && Array.isArray(data.transactions) && data.transactions.length > 0) {

            data.transactions.forEach(transaction => {

                if (transaction.type === 'credit') {
                    total = total + parseFloat(transaction.total)
                }

                if (transaction.type === 'debit') {
                    total = total - parseFloat(transaction.total)
                }

                currency = transaction.currency

            })

        }

        if (total > 0) {
            return <div className="e-history-head-total">+ {this.withCr(Math.abs(total), currency)}</div>
        }

        if (total < 0) {
            return <div className="e-history-head-total">- {this.withCr(Math.abs(total), currency)}</div>
        }

        return <div className="e-history-head-total">{this.withCr(total, currency)}</div>
    }


    /* Draw time */
    _time = data => {

        if (data.createdAt) {

            const date = moment(data.createdAt).format("YYYY-MM-DD")
            const today = moment(new Date()).format("YYYY-MM-DD")

            const yesterdayD = new Date()
            yesterdayD.setDate(yesterdayD.getDate() - 1)
            const yesterday = moment(yesterdayD).format("YYYY-MM-DD")

            let text = date

            if (moment(date).isSame(today, 'day')) {
                text = this.tr('Today')
            }
            else if (moment(date).isSame(yesterday, 'day')) {
                text = this.tr('Yesterday')
            }

            return (
                <div className="e-history-head-datetime">
                    <div className="e-history-head-time">{moment(data.createdAt).format("HH:mm")}</div>&nbsp;
                    <div className="e-history-head-date">{text}</div>
                </div>
            )
        }
    }

    eb5Cards = (data, type, box, cards) => {
        // const cards = [...cards2, ...cards2]

        const { params } = this.props
        const { mediapoint } = params

        let game = null

        /* GAME RESULTS */
        if (data.results && Array.isArray(data.results) && data.results.length > 0) {
            const index = data.results.findIndex(e => e.type === type && (parseInt(e.box) === box || (box === 'dealer' && e.box === 'dealer')))
            if (index > -1) {
                game = {
                    name: data.results[index].result,
                    multiplier: data.results[index].multiplier
                }
            }
        }

        const style = cards.length > 5 ? {} : {}

        if (cards && cards.length > 0) {
            return (
                <div className={`e-history-cards-box-item ${type}`} style={style}>
                    {/* {cards.length > 0 ? <div className="e-history-cards-box-text">{utils.translate(title)}{box ? ` - ${box}` : ''}</div> : null} */}
                    {game !== null && game.name.length < 3 ? <p className={`eb5-history-result ${type}`}>{utils.translate(game.name)}</p> : <p></p>}
                    <div className="e-history-cards">
                        {cards.map((card, index) => {
                            const style = { marginLeft: !index ? 0 : -11.5 }
                            return (
                                <div key={`cc-${index}`} className="e-history-card-item" style={style}>
                                    <Picture src={`${mediapoint}/cards2/${card.image}`} alt="Card" />
                                </div>
                            )
                        }
                        )}
                    </div>
                </div>
            )
        }

        return null

    }


    /* Operations list */
    operationsList = item => {

        if (item.processes && Array.isArray(item.processes) && item.processes.length > 0) {

            let total = 0
            let totalWin = 0

            let currency = "USD"

            let totalWinTransactions = 0

            if (item.transactions && Array.isArray(item.transactions) && item.transactions.length > 0) {
                currency = item.transactions[0].currency
                item.transactions.forEach(transaction => {
                    if (transaction.type === 'credit') {
                        totalWinTransactions += parseFloat(transaction.total)
                    }
                })
            }

            let boxes = item.boxes ? item.boxes : []

            item.processes.forEach(item => {

                if (item.total) {
                    if (item.type !== "maxpay") {
                        total += parseFloat(item.total)
                    }
                }

                if (item.win) {
                    totalWin += parseFloat(item.win)
                }
            })

            let gameProcesses = [[], [], [], [], []]
            let array = item.processes

            boxes.forEach((box) => {
                gameProcesses[box] = array.filter((e) => parseInt(e.box) === parseInt(box))
            })

            const dealerCards = item.cards.filter(card => card.type === "dealer" && card.box === "dealer")

            // console.log(item.processes)

            return (
                <div className="history-operations">
                    <table className="operations-table">
                        <thead>
                            <tr>
                                <th className="table-first" colSpan={2}>{this.tr("Dealer")}</th>
                                <th colSpan={2}>{this.tr("BOXES")}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr key={`h-o-dealer`} className={`item with-card`}>
                                <td className="table-second" colSpan={2}>
                                    {this.eb5Cards(item, "dealer", 'dealer', dealerCards)}
                                </td>
                                <td colSpan={2}>
                                    <div className="history-box-dots">
                                        {
                                            [0, 1, 2, 3, 4].map(item => {
                                                let style = (item === 0 || item === 4) ? "second" : (item === 1 || item === 3) ? "first" : ""
                                                if (boxes.includes(item)) {
                                                    style += ' active'
                                                }
                                                return (
                                                    <div className={`game-dot ${style}`} key={`dot-${item}`}/>
                                                )
                                            })
                                        }
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <table className="operations-table">

                        <thead>
                            <tr>
                                <th className="table-first"></th>
                                <th className="table-second">{this.tr("Cards")}</th>
                                <th>{this.tr("Type")}</th>
                                <th>{this.tr("Amount")}</th>
                                <th>{this.tr("Paid")}</th>
                            </tr>
                        </thead>
                        <tbody>

                            {
                                gameProcesses.map((array, ind) => {
                                    if (array.length > 0) {
                                        return array.map((process, index) => {
                                            let text = this.tr(process.reason)
                                            const hand1Index = item.cards.findIndex(e => e.type === "hand-1" && parseInt(e.box) === ind)
                                            const isSplitted = hand1Index !== -1
                                            let cardType = process.type === 'ante' ? isSplitted ? 'hand-1' : 'player' : process.type

                                            const cards = item.cards.filter(card => card.type === cardType && parseInt(card.box) === ind)
                                            const cards2 = item.cards.filter(card => card.type === 'hand-2' && parseInt(card.box) === ind)
                                            const processStyle = cards.length > 0 ? "with-card" : ""
                                            return (
                                                <tr key={`h-o-${index}`} className={`item ${processStyle}`}>
                                                    {index === 0 ? <td className="table-first" rowSpan={array.length}>{`${this.tr("BOX")} - ${ind + 1}`}</td> : null}
                                                    <td className="table-second">
                                                        {this.eb5Cards(item, cardType, ind, cards)}
                                                        {cardType === 'hand-1' ? this.eb5Cards(item, 'hand-2', ind, cards2) : null}
                                                    </td>
                                                    <td>{text}</td>
                                                    <td>{this.withCr(process.total, currency)}</td>
                                                    <td className="value">{this.withCr(process.win ? process.win : 0, currency)}</td>
                                                </tr>
                                            )
                                        })
                                    }
                                })
                            }

                            <tr key={`h-o-total`}>
                                <td className="table-first"></td>
                                <td className="table-second"></td>
                                <td>{this.tr('Total')}</td>
                                <td className="total">{this.withCr(Math.abs(total), currency)}</td>
                                <td className="total">{this.withCr(Math.abs(totalWinTransactions), currency)}</td>
                            </tr>

                        </tbody>
                    </table>
                </div>
            )
        }

        return null
    }

    /* Draw Refund */
    _refund = item => {

        if (item.transactions && Array.isArray(item.transactions) && item.transactions.length > 0) {
            const result = item.transactions.filter(e => e.reason === "Replenishment of the amount" || e.reason === "Return of funds")
            if (result && Array.isArray(result) && result.length > 0) {
                return (
                    <div className="e-history-refund-transactions">
                        <div className="e-history-refund-transaction-title">{this.tr("Refunds")}</div>
                        {result.map((transaction, i) =>
                            <div className="e-history-refund-transaction" key={`ref-${i}`}>
                                <div className="e-history-refund-transaction-name">{this.tr(transaction.reason)}</div>
                                <div className="e-history-refund-transaction-value">{this.withCr(transaction.total, transaction.currency)}</div>
                            </div>
                        )}
                    </div>
                )
            }
        }
    }

    render = () => {

        /* Props and state */
        const { historyData, loadMore, mobile, close, params } = this.props
        const { active } = this.state

        const { histories, historyHasMore } = historyData
        const { mediapoint, type } = params

        /* Fields */
        const bottomStyle = histories.length > 10 ? 'initial' : ''

        return (
            <div className='e-history-content'>

                {/* Modal Header */}
                {!mobile &&
                    <div className='e-history-header'>
                        {this.tr("History")}
                        <div onClick={() => close()} className="e-history-close">
                            <Picture src={`${mediapoint}/images/close.png`} alt="CLOSE" />
                        </div>
                    </div>
                }

                {/* Modal Body */}
                <div className='e-history-body' ref={ref => this._history = ref}>

                    {/* The current game */}
                    {/* {this._currentGame()} */}

                    {/* Old games */}
                    {histories.map((item, index) => {

                        let endBalance = parseFloat(item.startBalance)

                        if (item.transactions && Array.isArray(item.transactions) && item.transactions.length > 0) {
                            item.transactions.forEach(transaction => {
                                if (transaction.type === 'credit') {
                                    endBalance = endBalance + parseFloat(transaction.total)
                                }
                                if (transaction.type === 'debit') {
                                    endBalance = endBalance - parseFloat(transaction.total)
                                }
                            })
                        }

                        return (
                            <div className={`e-history-item ${index === active ? 'visible' : 'default'}`} key={`e-his-${index}`}>

                                {/* Draw history head */}
                                <div onClick={() => this.setState({ active: active === index ? -1 : index })} className={`e-history-head ${index === active ? 'e-history-active-head' : ''}`}>

                                    <div className="e-history-number">
                                        {this.tr("Game")} #{item.number}
                                        {/* {index === 0 && <div className="history-number-text"> (LAST GAME)</div>} */}
                                    </div>

                                    <div className="e-history-head-right">
                                        {this._total(item)}
                                        {this._time(item)}
                                        <CaretDownOutlined />
                                    </div>

                                </div>

                                <div className={`e-history-hidden-box ${index === active ? 'e-history-hidden-box-active' : ''}`}>

                                    {item.endReason ? <div className="e-history-reason-error">{this.tr(item.endReason)}</div> : null}

                                    {(item.transactions && Array.isArray(item.transactions) && item.transactions.length > 0) &&
                                        <div className="history-operations">

                                            {(item.startBalance !== null || item.startBalance !== undefined) && <div className="e-history-transaction-balance">{this.tr("Balance before the game:")} {this.withCr(item.startBalance, item.transactions[0].currency)}</div>}
                                            {endBalance > 0 && <div className="e-history-transaction-balance">{this.tr("Balance after the game:")} {this.withCr(endBalance, item.transactions[0].currency)}</div>}

                                            {this._refund(item)}

                                            {this.operationsList(item, index)}
                                        </div>
                                    }

                                </div>
                            </div>
                        )
                    })}

                    {historyHasMore &&
                        <div className={`e-history-bottom ${bottomStyle}`}>
                            <div className="e-history-load-more" onClick={() => loadMore()}>{this.tr("Load more")}</div>
                        </div>
                    }

                    {histories.length > 4 ? <div className="history-bottom-space" /> : null}

                </div>
            </div>

        )

    }

}

export default History